module.exports = __webpack_public_path__ + "static/img/pc-01.ab62be8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w0/pc-01.jpg
// module id = Wq8N
// module chunks = 1